import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ShButtonComponent } from '@gbr-monorepo/gbr-shui';

@Component({
    selector: 'app-button-link',
    templateUrl: './button-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, ShButtonComponent]
})
export class ButtonLinkComponent {
    public readonly link = input.required<string>();
    public readonly ariaLabel = input.required<string>();
    public readonly color = input.required<'primary' | 'secondary' | 'tertiary'>();
    public readonly icon = input<string>();
    public readonly label = input<string>();
    public readonly newTab = input<boolean>(false);

    public readonly isInternal = computed(() => {
        const url = this.link();
        return url.startsWith('/') || url.startsWith('./') || url.startsWith('../') || !url.includes('://');
    });

    public readonly target = computed(() => (this.newTab() ? '_blank' : '_self'));

    public readonly rel = computed(() => (this.newTab() ? 'noopener noreferrer' : null));
}
